export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./balance-operation.vue?vue&type=template&id=43ffb68d"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/balance-operation/balance-operation.vue?vue&type=template&id=43ffb68d
// module id = Zexg
// module chunks = 0